import { Injectable } from "@angular/core";
import { CanActivate, Router, UrlTree } from "@angular/router";
import { Observable } from "rxjs";
import { map } from "rxjs/operators";
import { FeatureFlagService } from "~/app/shared/featureFlag.service";

@Injectable({
  providedIn: "root",
})
export class EmotionTransferGuard implements CanActivate {
  constructor(
    private router: Router,
    private featureFlagService: FeatureFlagService
  ) {}

  canActivate(): Observable<boolean | UrlTree> {
    return this.featureFlagService
      .getFlags()
      .pipe(
        map((flags) =>
          flags.emotionTransfer
            ? true
            : this.router.parseUrl("/projects/not-found")
        )
      );
  }
}
